var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-card1-gallery-card",class:_vm.rootClassName},[_c('img',{staticClass:"gallery-card1-image",attrs:{"alt":_vm.imageAlt,"src":_vm.imageSrc}}),_c('h2',{staticClass:"gallery-card1-text1"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"gallery-card1-text2"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }